import { Injectable } from '@angular/core';
import { ApiService } from '../utilities/api.service';

@Injectable({
    providedIn: 'root',
})
export class CommonHelperService {
    proofPrev: any;

    constructor(public _apiService: ApiService) { }

    signatures: { [key: string]: string } = {
        JVBERi0: "application/pdf",
        iVBORw0KGgo: "image/png",
        "/9j/": "image/jpg",
    };

    getBlob(baseFile: any) {
        var mimeType = this.detectMimeType(baseFile);
        if (mimeType) {
            var blob = this.b64toBlob(baseFile, mimeType);
            this.proofPrev = URL.createObjectURL(blob);
            return this.proofPrev;
        }
    }

    public detectMimeType(b64: any): string | undefined {
        for (var s in this.signatures) {
            if (b64.indexOf(s) === 0) {
                return this.signatures[s];
            }
        }
        // Explicitly return undefined if no match is found
        return undefined;
    }


    public b64toBlob(b64Data: any, contentType: string): Blob {
        contentType = contentType || '';
        let sliceSize = 512;

        var byteCharacters = atob(b64Data);
        var byteArrays = [];

        for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            var slice = byteCharacters.slice(offset, offset + sliceSize);

            var byteNumbers = new Array(slice.length);
            for (var i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }

            var byteArray = new Uint8Array(byteNumbers);

            byteArrays.push(byteArray);
        }

        var blob = new Blob(byteArrays, { type: contentType });
        return blob;
    }
}
